import NProgress from "nprogress"

NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false,
})
